export const styles = {
  container: {
    width: "100%",
    height: "100%",
  },
  mapWrapper: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexFlow: "row nowrap",
    justifyContent: "center",
    padding: 0,
    position: "relative",

    "& .gm-style .gm-style-iw-c": {
      border: "1px solid #E2E2FC !important",
      backgroundColor: "white !important",
      color: "#011533 !important",
      fontSize: "14px !important",
      lineHeight: "20px !important",
      padding: "8px 10px !important",

      "& .gm-style-iw-d": {
        overflow: "hidden !important",
      },

      "& > button": {
        display: "none !important",
      },
    },

    "& .gm-style-iw-tc": {
      display: "none",
    },
  },

  selectedCitiesList: {
    display: "flex",
    justifyContent: "space-between",
    margin: "26px 0 24px",
    alignItems: "center",
  },
  selectedCity: {
    marginRight: "8px",
    padding: "4px 12px",
    // border: "1px solid #BDBDBD",
    borderRadius: "8px",
    background: "#C2C8D1",
    color: "#000000",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "18px",
  },
  mr_10: {
    marginRight: "10px",
  },
  showOperatingZoneWrapper: {
    display: "flex",
    alignItems: "center",
    marginLeft: "-14px",
  },
  font_size_12: {
    fontSize: 12,
  },
  font_size_14: {
    fontSize: 14,
  },
  cursor: {
    cursor: "pointer",
  },
  usMissionsCheckbox: {
    display: "flex",
    alignItems: "center",
    position: "absolute",
    bottom: "67px",
    background: "#FFFFFF",
    borderRadius: "5px",
    padding: "0 14px 0 0",
    marginLeft: "20px",
    cursor: "default",
    "& > p": {
      zIndex: 2,
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "18px",
    },
  },
};
